import { render, staticRenderFns } from "./AddAssetMaster.vue?vue&type=template&id=6c958570&"
import script from "./AddAssetMaster.vue?vue&type=script&lang=js&"
export * from "./AddAssetMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports